import {NumberObjectArray} from "../models/visualisation-data.interface";
import {colourObj} from "../data/colours";

export function getLabels(dataGroup: NumberObjectArray[], width: number) {
    const legendPositions = [{cx: width / 2 - width / 5, cy: 150}, {
        cx: width / 2 + width / 7.5, cy: 190
    }, {cx: width / 2 + width / 25, cy: 300}];

    return dataGroup[1].map((g, index) => Object.entries(g).map(([key, val], innerIndex) => ({
        ...legendPositions[index], val, oldVal: Object.values(dataGroup[0][index])[innerIndex], color: colourObj[key],
    }))).flat();
}